import { render } from "./ImageV4.vue?vue&type=template&id=04bf27f8"
import script from "./ImageV4.vue?vue&type=script&lang=js"
export * from "./ImageV4.vue?vue&type=script&lang=js"

import "./ImageV4.vue?vue&type=style&index=0&id=04bf27f8&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__